<template>
    <div>
        <div class="table-header">
                <h2>详细数据</h2>
                <button class="export-btn" @click="exportExcel">导出EXCEL</button>
            </div>
        <vxe-table
          border
          highlight-hover-row
          ref="xTable"
          :data="table_data">
            <vxe-table-column
                v-for="column in table_columns"
                :key="column.field"
                :field="column.field"
                :title="column.name"
                sortable
            >
            </vxe-table-column>
        </vxe-table>
    </div>
</template>
<script>
import { DATA_KEYS } from './_data_select'
import XLSX from 'xlsx'
export default {
    props: {
        building_data_items: Array,
        data_types: Array
    },
    computed: {
        table_columns () {
            const columns = [{
                name: '城市',
                field: 'city'
            }, {
                name: '楼盘名称',
                field: 'name'
            }]
            const data_types = this.data_types.map((name) => {
                return {
                    name,
                    field: DATA_KEYS[name]
                }
            })
            columns.push(...data_types)
            return columns
        },
        table_data () {
            return this.building_data_items
        }
    },
    methods: {
        exportExcel () {
            const header = document.querySelector('.vxe-table--header thead');
            const body = document.querySelector('.vxe-table--body tbody');
            const table = document.createElement('table')
            table.innerHTML = header.innerHTML + body.innerHTML
            const wb = XLSX.utils.table_to_book(table, {sheet:"Sheet JS"});
            XLSX.writeFile(wb, '楼盘对比.xlsx')
        }
    }
}
</script>